export default __webpack_public_path__ + "static/media/misc-closetA-1440w.e3a14823.png";